<template>
  <div class="cuti">
    <BackSection :menu="name" />
    <div class="container-fluid">
      <ChangeEo />
    </div>
  </div>
</template>

<script>
import ChangeEo from "@/components/FormChangeEo.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      name: "Form Overtime",
    };
  },
  components: {
    ChangeEo,
    BackSection,
  },
};
</script>
